<template>
    <b-modal id="ModalAutorizacionInternacion"
      size="custom-lg-max"
      title="Autorizacion Internacion"
      @ok="guardarModal"
      @hidden="verificarModal"
      @cancel="cancelarGuardado"
      @show="precargarAutorizacion"
    >
      <template #modal-header="{ close }">
        <div class="container row">
          <div class="col-sm-6 pl-0">
            <h5 class="modal-title">Datos de "Autorizacion de Internacion"</h5>
          </div>
        </div>
        <button
        type="button"
        aria-label="Close"
        class="close"
        @click="close()"
      >×</button>

      </template>
      <template>
        <div class="container">
        <div class="row">
          <label for="aviso"> Aqui se llena los datos del garante o familiar que autoriza la atencion de servicios y medicamentos</label>
         </div>
         <div class="row mb-2 mt-3">
          <div class="col-sm-2 text-center">
            <button
              class="btn w-100"
              :class="isSistema ? 'btn-success' : 'btn-secondary'"
              @click="setModoSistema"
              :disabled="isEdit && !isSistema"
            >
              Sistema
            </button>
          </div>
          <div class="col-sm-6">
            <ComboPaciente
              ref="comboPacienteSistema"
              id="comboPaciente"
              v-on:addPaciente="AddPaciente"
              :havePreCierre="!isSistema"
              :edit="!!sistemaData.pacienteOption"
              :paciente="sistemaData.pacienteOption"
              :key="sistemaData.pacienteId || (isSistema ? 'sistema-on' : 'sistema-off')"
            />
          </div>
          <div class="col-sm-2">
            <input
              id="inputCi"
              type="text"
              class="form-control"
              placeholder="CI"
              v-model="sistemaData.ci"
              :disabled="!isSistema"
            >
          </div>
          <div class="col-sm-2">
            <input
              id="inputParestesco"
              type="text"
              class="form-control"
              placeholder="Parentesco"
              v-model="sistemaData.parentesco"
              :disabled="!isSistema"
            >
          </div>
         </div>
         <div class="row">
          <div class="col-sm-2 text-center">
            <button
              class="btn w-100"
              :class="!isSistema ? 'btn-success' : 'btn-secondary'"
              @click="setModoManual"
              :disabled="isEdit && isSistema"
            >
              Manual
            </button>
          </div>
          <div class="col-sm-6">
            <input
              id="inputNombreFamiliar"
              type="text"
              class="form-control"
              placeholder="Nombre Familiar"
              v-model="manualData.nombre"
              :disabled="isSistema"
            >
          </div>
          <div class="col-sm-2">
            <input
              id="inputCi"
              type="text"
              class="form-control"
              placeholder="CI"
              v-model="manualData.ci"
              :disabled="isSistema"
            >
          </div>
          <div class="col-sm-2">
            <input
              id="inputParentesco"
              type="text"
              class="form-control"
              placeholder="Parentesco"
              v-model="manualData.parentesco"
              :disabled="isSistema"
            >
          </div>
         </div>
        </div>
      </template>
      <template #modal-footer="{ ok, cancel }">
        <button class="btn btn-outline-dark" @click="cancel()">
          Cancelar
        </button>
        <button class="btn btn-success text-white" @click="ok()">
          Guardar
        </button>
      </template>
    </b-modal>
  </template>
<script>

import ComboPaciente from '@/modules/tratamiento/components/ThePatient.vue';
import axios from '@/modules/common/axiosERP';
import { util } from '@/plugins/util';

export default {
  name: 'ModalAutorizacionInternacion',
  components: {
    ComboPaciente,
  },
  props: {
    dataPaciente: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    autorizacion: {
      type: Object,
      required: false,
      default: null,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isSistema: false,
      sistemaData: {
        nombre: '',
        ci: '',
        parentesco: '',
        pacienteId: null,
        pacienteOption: null,
      },
      manualData: {
        nombre: '',
        ci: '',
        parentesco: '',
      },
    };
  },
  created() {
  },
  methods: {
    setModoSistema() {
      this.isSistema = true;
      this.limpiarDataManual();
    },
    setModoManual() {
      this.isSistema = false;
      this.limpiarDataSistema();
    },
    precargarAutorizacion() {
      if (!this.autorizacion) {
        return;
      }
      const isManualRaw = this.autorizacion.is_manual;
      const isManual = isManualRaw === 1 || isManualRaw === true;
      this.isSistema = !isManual;
      if (this.isSistema) {
        this.sistemaData = {
          nombre: this.autorizacion.nombre || '',
          ci: this.autorizacion.ci || '',
          parentesco: this.autorizacion.parentesco || '',
          pacienteId: this.autorizacion.paciente_id || null,
          pacienteOption: null,
        };
        if (this.sistemaData.pacienteId) {
          this.buscarPacientePorId(this.sistemaData.pacienteId);
        } else if (this.isEdit && this.sistemaData.ci) {
          this.$nextTick(async () => {
            const child = this.$refs.comboPacienteSistema;
            if (child && typeof child.seleccionarPacientePorQuery === 'function') {
              await child.seleccionarPacientePorQuery(this.sistemaData.ci);
            }
          });
        }
      } else {
        this.manualData = {
          nombre: this.autorizacion.nombre || '',
          ci: this.autorizacion.ci || '',
          parentesco: this.autorizacion.parentesco || '',
        };
      }
    },
    async buscarPacientePorId(id) {
      try {
        const response = await axios.get(`/clinic/patient/secure_medic/${id}`);
        const datos = response.data.data;
        const paciente = datos && datos.paciente ? datos.paciente : null;
        if (paciente) {
          // Asegurar shape para el combo (id, full_name, ci)
          this.sistemaData.pacienteOption = {
            id: paciente.id,
            full_name: paciente.full_name || paciente.nombre_completo || '',
            ci: paciente.ci || paciente.nit || '',
          };
        }
      } catch (e) {
        // Silencioso; el combo seguirá vacío si falla
      }
    },
    AddPaciente(pacient) {
      // Evento emitido por ComboPaciente
      if (!pacient || !pacient.pacienteSelect) {
        this.sistemaData.nombre = '';
        this.sistemaData.pacienteId = null;
        this.sistemaData.pacienteOption = null;
        return;
      }
      const nombre = pacient.pacienteSelect.full_name || '';
      const ci = (pacient.datosPaciente && (pacient.datosPaciente.ci || pacient.datosPaciente.nit)) || '';
      this.sistemaData.nombre = nombre;
      this.sistemaData.pacienteId = pacient.pacienteSelect.id || null;
      this.sistemaData.ci = ci;
      this.sistemaData.pacienteOption = pacient.pacienteSelect;
    },
    guardarModal() {
      // Armar payload según modo
      const base = this.isSistema
        ? {
          nombre: this.sistemaData.nombre,
          ci: this.sistemaData.ci,
          parentesco: this.sistemaData.parentesco,
          is_manual: false,
          paciente_id: this.sistemaData.pacienteId,
        }
        : {
          nombre: this.manualData.nombre,
          ci: this.manualData.ci,
          parentesco: this.manualData.parentesco,
          is_manual: true,
        };

      // Validación
      if (!base.nombre || !base.ci) {
        util.showNotify('Por favor complete todos los campos requeridos', 'error');
        return;
      }

      // Emitir los datos al componente padre
      this.$emit('autorizacion-guardada', {
        confirmacion_autorizacion: true,
        autorizacion: {
          id: (this.autorizacion && this.autorizacion.id) ? this.autorizacion.id : 0,
          nombre: base.nombre,
          ci: base.ci,
          parentesco: base.parentesco,
          is_manual: base.is_manual,
          paciente_id: base.paciente_id || null,
        },
      });

      this.store = true;
    },
    cancelarGuardado() {
      this.store = false;
      this.resetData();
    },
    verificarModal() {
      this.resetData();
    },
    resetData() {
      this.isSistema = false;
      this.sistemaData = {
        nombre: '',
        ci: '',
        parentesco: '',
        pacienteId: null,
        pacienteOption: null,
      };
      this.manualData = {
        nombre: '',
        ci: '',
        parentesco: '',
      };
    },
    limpiarDataSistema() {
      this.sistemaData = {
        nombre: '',
        ci: '',
        parentesco: '',
        pacienteId: null,
        pacienteOption: null,
      };
    },
    limpiarDataManual() {
      this.manualData = {
        nombre: '',
        ci: '',
        parentesco: '',
      };
    },
  },
};
</script>

<style scoped>
.bg-abierto {
  background: #f8cb9e;
}
</style>
